import React from 'react';
import {useTrackHeaderOriginClick} from '../hooks/useOriginClickTrackingFunction';
import {AboutYouLogo} from '../../../features/AboutYouLogo/AboutYouLogo';

interface HeaderAboutYouLogoWrapperProps {
  className?: string;
}
export const HeaderAboutYouLogoWrapper: React.FC<
  HeaderAboutYouLogoWrapperProps
> = ({className}) => {
  const trackOriginClick = useTrackHeaderOriginClick();

  return (
    <AboutYouLogo
      className={className}
      disableSvgLogo
      disableLoggedInUserUpdates={false}
      trackOriginClickFunction={trackOriginClick}
    />
  );
};
